import { h, render } from 'preact'
import { isMobileOnly } from "react-device-detect"

const cssEnum = {
    Single: 'single',
    MediaQuery: 'mediaQuery',
    MobileOrDesktop: 'mobileOrDesktop'
}

const intersectConfig = {
    root: null,
    rootMargin: "200px",
    thershold: 0
}

var loadedWidgets = [];

const getCssBasePath = () => {
    const result = typeof CSS_BASE_PATH !== 'undefined' ? CSS_BASE_PATH : ''
    return result
}

const addLinkElement = (attributes) => {
    var link = document.createElement('link')
    Object.entries(attributes).forEach(([key, value]) => link.setAttribute(key, value))
    document.head.appendChild(link)
}

const insertCss = (cssName, mediaQuery) => {
    let attributes = {
        rel: 'stylesheet',
        href: `${PUBLIC_PATH}${getCssBasePath()}${cssName}.${CSS_HASH}.css`,
        type: 'text/css'
    }
    if (mediaQuery)
        attributes.media = mediaQuery

    addLinkElement(attributes)
}

const insertCssPreload = (cssName) => {
    const attributes = {
        rel: 'preload',
        href: `${PUBLIC_PATH}${getCssBasePath()}${cssName}.${CSS_HASH}.css`,
        as: 'style'
    }
    addLinkElement(attributes)
}

const preconnectToOrigin = (url) => {
    const attributes = {
        rel: 'preconnect',
        href: url
    }
    addLinkElement(attributes)
}

const loadCss = (widgetCss) => {
    if (!widgetCss) return

    if (widgetCss.hasCommon) {
        const commonCss = `${widgetCss.prefix}-common`
        insertCssPreload(commonCss)
        insertCss(commonCss)
    }

    switch (widgetCss.type) {
        case cssEnum.MediaQuery:
            const mobileCss = `${widgetCss.prefix}-mobile`
            insertCssPreload(mobileCss)
            insertCss(mobileCss, '(max-width:767px)')

            const tabletCss = `${widgetCss.prefix}-tablet`
            insertCssPreload(tabletCss)
            insertCss(tabletCss, '(min-width:768px) and (max-width:1023px)')

            const desktopCss = `${widgetCss.prefix}-desktop`
            insertCssPreload(desktopCss)
            insertCss(desktopCss, '(min-width:1024px)')
            break
        case cssEnum.Single:
            const css = `${widgetCss.prefix}`
            insertCssPreload(css)
            insertCss(css)
            break
        case cssEnum.MobileOrDesktop:
            if (isMobileOnly) {
                const mobileCss = `${widgetCss.prefix}-mobile`
                insertCssPreload(mobileCss)
                insertCss(mobileCss)
            }
            else {
                const desktopCss = `${widgetCss.prefix}-desktop`
                insertCssPreload(desktopCss)
                insertCss(desktopCss)
            }
            break
    }
}

const getParametersFromElement = (element) => {
    let result = {}

    for (let i = 0; i < element.attributes.length; i++) {
        const { nodeName, nodeValue } = element.attributes[i]

        if (nodeName !== 'fxs-widget' && nodeName !== 'name') {
            const key = nodeName
            result[key] = nodeValue
        }
    }

    return result
}
const isElementLoaded = (entry) => {
    return loadedWidgets.find(element => element.isEqualNode(entry))
}
const loadWidget = (widget, reset = false) => {
    var elements = document.querySelectorAll(`div[fxs-widget][name="${widget.name}"]`)

    if (elements.length > 0) {
        widget.import().then(module => {
            for (var i = 0; i < elements.length; i++) {
                const observer = new IntersectionObserver(function(entries){
                    entries.forEach(entry => {

                        if (entry.isIntersecting && isElementLoaded(entry.target) == undefined) {
                
                            if (reset && entry.target.lastElementChild)
                                entry.target.element.removeChild(entry.target.lastElementChild)
                            
                            var parameters = getParametersFromElement(entry.target)
                            
                            render(< module.default {...parameters} />, entry.target, entry.target.lastElementChild)
                
                            loadedWidgets.push(entry.target)
                        }
                    });
                }, intersectConfig);
                
                observer.observe(elements[i]);
            }
        })

        if (!widget.disableCss) {
            loadCss(commonCss)
            loadCss(widget.css)
        }
        if (widget.preconnectUrls)
            widget.preconnectUrls.forEach(url => preconnectToOrigin(url))
    }
}

const commonCss = {
    prefix: 'common',
    type: cssEnum.Single,
    hasCommon: false
}

const widgets = [
    {
        name: 'calendar',
        import: () =>
            import( /*webpackChunkName: 'calendar'*/ "./widgets/calendar"),
        css: {
            prefix: 'calendar',
            type: cssEnum.MobileOrDesktop,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL, AUTHORIZATION_I3_API_URL, PUSH_API_URL]
    },
    {
        name: 'calendar-historical',
        import: () =>
            import( /*webpackChunkName: 'calendar-historical'*/ "./widgets/calendar-historical"),
        css: {
            prefix: 'calendar-historical',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'calendar-latestpost',
        import: () =>
            import( /*webpackChunkName: 'calendar-latestpost'*/ "./widgets/calendar-latestpost"),
        css: {
            prefix: 'calendar-latestpost',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'calendar-recent-next',
        import: () =>
            import( /*webpackChunkName: 'calendar-recent-next'*/ "./widgets/calendar-recent-next"),
        css: {
            prefix: 'calendar-recent-next',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL, AUTHORIZATION_I3_API_URL, PUSH_API_URL]
    },
    {
        name: 'calendar-related-events',
        import: () =>
            import( /*webpackChunkName: 'calendar-related-events'*/ "./widgets/calendar-related-events"),
        css: {
            prefix: 'calendar-related-events',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL, AUTHORIZATION_I3_API_URL, PUSH_API_URL]
    },
    {
        name: 'calendar-title-description',
        import: () =>
            import( /*webpackChunkName: 'calendar-title-description'*/ "./widgets/calendar-title-description"),
        css: {
            prefix: 'calendar-title-description',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'calendar-topevents-subscription',
        import: () =>
            import( /*webpackChunkName: 'calendar-topevents-subscription'*/ "./widgets/calendar-topevents-subscription"),
        css: {
            prefix: 'calendar-topevents-subscription',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'calendar-whyMatters',
        import: () =>
            import( /*webpackChunkName: 'calendar-whyMatters'*/ "./widgets/calendar-whyMatters"),
        css: {
            prefix: 'calendar-whyMatters',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'calendar-frequency-source',
        import: () =>
            import( /*webpackChunkName: 'calendar-frequency-source'*/ "./widgets/calendar-frequency-source"),
        css: {
            prefix: 'calendar-frequency-source',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'calendar-event-data',
        import: () =>
            import( /*webpackChunkName: 'calendar-event-data'*/ "./widgets/calendar-event-data"),
        css: {
            prefix: 'calendar-event-data',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'calendar-faq',
        import: () =>
            import( /*webpackChunkName: 'calendar-faq'*/ "./widgets/calendar-faq"),
        css: {
            prefix: 'calendar-faq',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },
        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'marketimpact-truerange',
        import: () =>
            import( /*webpackChunkName: 'marketimpact-truerange'*/ "./widgets/marketimpact-truerange"),
        css: {
            prefix: 'marketimpact-truerange',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },

        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'marketimpact-truerangevsdeviation',
        import: () =>
            import( /*webpackChunkName: 'marketimpact-truerangevsdeviation'*/ "./widgets/marketimpact-truerangevsdeviation"),
        css: {
            prefix: 'marketimpact-truerangevsdeviation',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },

        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'marketimpact-volatility',
        import: () =>
            import( /*webpackChunkName: 'marketimpact-volatility'*/ "./widgets/marketimpact-volatility"),
        css: {
            prefix: 'marketimpact-volatility',
            type: cssEnum.MediaQuery,
            hasCommon: true
        },

        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'marketimpact-actualdeviation',
        import: () =>
            import( /*webpackChunkName: 'marketimpact-actualdeviation'*/ "./widgets/marketimpact-actualdeviation"),
        css: {
            prefix: 'marketimpact-actualdeviation',
            type: cssEnum.Single,
            hasCommon: true
        },

        preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'monitoring-signals',
        import: () =>
            import( /*webpackChunkName: 'monitoring-signals'*/ "./widgets/monitoring-signals"),
        css: {
                prefix: 'monitoring-signals',
                type: cssEnum.Single,
                hasCommon: false
            },
        preconnectUrls: [MONITORING_API_URL]
    },
    {
        name: 'calendar-settings',
        import: () =>
            import( /*webpackChunkName: 'calendar-settings'*/ "./widgets/calendar-settings"),
            css: {
                prefix: 'calendar-settings',
                type: cssEnum.MediaQuery,
                hasCommon: true
            },
            preconnectUrls: [CALENDAR_API_URL]
    },
    {
        name: 'dates-test',
        import: () =>
            import( /*webpackChunkName: 'dates-test'*/ "./widgets/dates-test"),
    },
]

window.fxsWidgets = window.fxsWidgets || {};
window.fxsWidgets.load = (widgetName, reset = false) => {
    const widget = widgets.find(x => x.name === widgetName)
    if (!widget) {
        console.error(`FXStreet Widgets v2: the widget "${widgetName}" does not exist.`)
    } else {
        loadWidget(widget, reset)
    }
};

window.fxsWidgets.loadAll = (reset = false) => {
    widgets.forEach(widget => loadWidget(widget, reset))
}

window.fxsWidgets.loaded = true

window.dispatchEvent(new Event('fxsWidgetsLoaded'))

widgets.forEach(widget => loadWidget(widget))
